import { Injectable, ViewContainerRef } from "@angular/core";
import { DwdmDiagramAbstractConverter } from "../../diagram/converter/dwdm-diagram-abstract-converter";
import { CircuitDiagram, EndpointDeviceElement, EndpointType } from "../../diagram/models/diagram.models";
import { DwdmCircuitDiagnosticData } from "../../dwdm-circuit.model";
import { DwdmDiagramDiagnosticConverterEndService } from "./dwdm-diagram-diagnostic-converter-end.service";
import { DwdmDiagramDiagnosticConverterIntermediatesService } from "./dwdm-diagram-diagnostic-converter-intermediates.service";
import { DwdmDiagramDiagnosticConverterLinksService } from "./dwdm-diagram-diagnostic-converter-links.service";

/**
 * Implementação de {@link DwdmDiagramAbstractConverter} para a tela de Diagnóstico.
 * Converte {@link DwdmCircuitDiagnosticData} em {@link CircuitDiagram}.
 */
@Injectable({
    providedIn: "root"
})
export class DwdmDiagramDiagnosticConverterService extends DwdmDiagramAbstractConverter {

    constructor(private readonly endConverterService: DwdmDiagramDiagnosticConverterEndService,
            private readonly intermediatesConverterService: DwdmDiagramDiagnosticConverterIntermediatesService,
            private readonly linksConverterService: DwdmDiagramDiagnosticConverterLinksService) {
        super();
    }

    public convert(dwdmCircuitDiagnosticData: DwdmCircuitDiagnosticData, diagnosticModalViewRef: ViewContainerRef) {
        const circuitDiagram: CircuitDiagram = {} as CircuitDiagram;
        const circuit = dwdmCircuitDiagnosticData.circuit;

        const stepMapData = {
            EndsStepModel: circuit.endsStepModel,
            TranspondersStepModel: circuit.transpondersStepModel,
            IntermediatesStepModel: circuit.intermediatesStepModel,
            LinksStepModel: circuit.linksStepModel,
            AmplifiersStepModel: circuit.amplifiersStepModel,
            OscManagementStepModel: circuit.oscManagementStepModel
        }

        const {aEnd, zEnd, intermediates, links} = this.convertModels({ circuitModels: stepMapData });

        const aEndIdentifier = this.endConverterService.convert(aEnd, dwdmCircuitDiagnosticData, diagnosticModalViewRef);
        circuitDiagram.aEnd = aEndIdentifier.endpoint as EndpointDeviceElement<EndpointType.A_END>;

        const zEndIdentifier = this.endConverterService.convert(
            zEnd, dwdmCircuitDiagnosticData, diagnosticModalViewRef);
        circuitDiagram.zEnd = zEndIdentifier.endpoint as EndpointDeviceElement<EndpointType.Z_END>

        const intermediatesIdentifier = this.intermediatesConverterService
            .convert(intermediates, dwdmCircuitDiagnosticData,diagnosticModalViewRef);
        circuitDiagram.intermediates = intermediatesIdentifier.map(intermediateIdentifier => intermediateIdentifier.intermediate);

        circuitDiagram.links = this.linksConverterService.convert(
            links, aEndIdentifier, zEndIdentifier, intermediatesIdentifier, dwdmCircuitDiagnosticData, diagnosticModalViewRef);

        circuitDiagram.showExternalLinks = true;

        return circuitDiagram;
    }
}
